import actionTypes from '@types/basic/layout'

export const setOpenKeys = payload => ({
  type: actionTypes.SET_MENU_DATA,
  payload: payload
})

export const setApplication = payload => ({
  type: actionTypes.SET_APPLICATION,
  payload: payload
})
